document.addEventListener("DOMContentLoaded", function () {
  const dateInput = document.getElementById("delivery-date");
  const timeSelect = document.getElementById("delivery-time");
  const addToCartBtn = document.querySelector('[data-add-to-cart], [name="add"]');
  const buyNowBtn = document.querySelector('[name="checkout"], [data-shopify="dynamic-checkout-button"]');

  if (!dateInput || !timeSelect) {
    console.warn("delivery-date or delivery-time element not found.");
    return;
  }

  // ===== CUSTOM POPUP FUNCTION =====
  function showPopup(message, title = "Notice") {
    // Remove any existing popup
    const existingPopup = document.querySelector('.custom-popup-overlay');
    if (existingPopup) existingPopup.remove();

    // Create overlay
    const overlay = document.createElement('div');
    overlay.className = 'custom-popup-overlay';
    overlay.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.5);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 99999;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
    `;

    // Create popup container
    const popup = document.createElement('div');
    popup.className = 'custom-popup';
    popup.style.cssText = `
      background: white;
      border-radius: 12px;
      padding: 24px;
      max-width: 400px;
      width: 90%;
      box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
      animation: slideIn 0.3s ease-out;
    `;

    // Add animation styles
    const style = document.createElement('style');
    style.textContent = `
      @keyframes slideIn {
        from {
          opacity: 0;
          transform: translateY(-20px);
        }
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }
    `;
    document.head.appendChild(style);

    // Create title
    const titleEl = document.createElement('h3');
    titleEl.textContent = title;
    titleEl.style.cssText = `
      margin: 0 0 12px 0;
      font-size: 20px;
      font-weight: 600;
      color: #333;
      text-align: center;
    `;

    // Create message
    const messageEl = document.createElement('p');
    messageEl.textContent = message;
    messageEl.style.cssText = `
      margin: 0 0 20px 0;
      font-size: 16px;
      line-height: 1.5;
      color: #666;
      white-space: pre-line;
      text-align: center;
    `;

    // Create button container
    const buttonContainer = document.createElement('div');
    buttonContainer.style.cssText = `
      display: flex;
      justify-content: flex-end;
      gap: 12px;
    `;

    // Create OK button
    const okButton = document.createElement('button');
    okButton.textContent = 'OK';
    okButton.style.cssText = `
      padding: 10px 24px;
      background: #000000;
      color: white;
      border: none;
      border-radius: 6px;
      font-size: 14px;
      font-weight: 500;
      cursor: pointer;
      transition: background 0.2s;
    `;
    okButton.onmouseover = () => okButton.style.background = '#000000';
    okButton.onmouseout = () => okButton.style.background = '#000000';
    okButton.onclick = () => overlay.remove();

    buttonContainer.appendChild(okButton);
    popup.appendChild(titleEl);
    popup.appendChild(messageEl);
    popup.appendChild(buttonContainer);
    overlay.appendChild(popup);
    document.body.appendChild(overlay);

    // Close on overlay click
    overlay.onclick = (e) => {
      if (e.target === overlay) overlay.remove();
    };

    // Close on escape key
    const closeOnEsc = (e) => {
      if (e.key === 'Escape') {
        overlay.remove();
        document.removeEventListener('keydown', closeOnEsc);
      }
    };
    document.addEventListener('keydown', closeOnEsc);
  }

  // Local YYYY-MM-DD for a Date object (avoids UTC shift)
  function localDateString(d = new Date()) {
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
  }

  const minDate = localDateString();
  dateInput.min = minDate;

  // Parse a time string to minutes since midnight. Returns null if can't parse.
  function parseTimeToMinutes(str) {
    if (!str) return null;
    str = String(str).trim();

    // If it's a range like "10:00 AM - 11:00 AM", take the left part
    if (/-|to/i.test(str)) {
      str = str.split(/-|to/i)[0].trim();
    }

    // Remove parentheses like "(slot)"
    str = str.replace(/\(.*\)/, "").trim();

    let m;
    // 12-hour with am/pm: "2:30 PM", "12 AM"
    m = str.match(/^(\d{1,2})(?::(\d{2}))?\s*(am|pm)$/i);
    if (m) {
      let hh = parseInt(m[1], 10);
      const mm = parseInt(m[2] || "0", 10);
      const mer = m[3].toLowerCase();
      if (mer === "pm" && hh < 12) hh += 12;
      if (mer === "am" && hh === 12) hh = 0;
      return hh * 60 + mm;
    }

    // 24-hour "14:30" or "9:00"
    m = str.match(/^(\d{1,2}):(\d{2})$/);
    if (m) {
      const hh = parseInt(m[1], 10);
      const mm = parseInt(m[2], 10);
      if (Number.isFinite(hh) && Number.isFinite(mm)) return hh * 60 + mm;
    }

    // Single hour "9" -> 9:00
    m = str.match(/^(\d{1,2})$/);
    if (m) {
      const hh = parseInt(m[1], 10);
      return hh * 60;
    }

    return null;
  }

  // Disable past time options when selected date is today
  function blockPastTimes() {
    const selectedDate = dateInput.value;
    const today = localDateString();

    // Reset all options
    Array.from(timeSelect.options).forEach(opt => {
      opt.disabled = false;
      opt.style.opacity = "";
      opt.style.color = "";
    });

    if (!selectedDate) return;

    if (selectedDate === today) {
      const now = new Date();
      const currentMinutes = now.getHours() * 60 + now.getMinutes();

      const MORNING_CUTOFF = 12 * 60;       // 12:00 PM
      const EVENING_CUTOFF = 18 * 60 + 30;  // 6:30 PM

      Array.from(timeSelect.options).forEach(opt => {
        if (!opt.value) return;

        let shouldDisable = false;

        const startTime = opt.dataset.start;
        const startMinutes = parseTimeToMinutes(startTime);

        // Morning slot (10 AM – 1 PM)
        if (startMinutes === 10 * 60) {
          if (currentMinutes >= MORNING_CUTOFF) shouldDisable = true;
        }

        // Evening slot (3 PM – 7 PM)
        if (startMinutes === 15 * 60) {
          if (currentMinutes >= EVENING_CUTOFF) shouldDisable = true;
        }

        // General past-time safety
        if (startMinutes !== null && startMinutes < currentMinutes) {
          shouldDisable = true;
        }

        if (shouldDisable) {
          opt.disabled = true;
          opt.style.opacity = "0.5";
          opt.style.color = "#999";
        }
      });

      // Clear selection if chosen slot is now disabled
      const selectedOpt = timeSelect.selectedOptions?.[0];
      if (selectedOpt && selectedOpt.disabled) {
        timeSelect.value = "";
      }
    }
  }

  // Toggle Add to Cart / Buy Now buttons
  function toggleButtons() {
    const enabled = dateInput.value && timeSelect.value;
    if (addToCartBtn) {
      addToCartBtn.disabled = !enabled;
      addToCartBtn.style.opacity = enabled ? "1" : "0.5";
      addToCartBtn.style.pointerEvents = enabled ? "auto" : "none";
    }
    if (buyNowBtn) {
      buyNowBtn.disabled = !enabled;
      buyNowBtn.style.opacity = enabled ? "1" : "0.5";
      buyNowBtn.style.pointerEvents = enabled ? "auto" : "none";
    }
  }

  // Basic date + time validation
  function validateInputs(e) {
    if (!dateInput.value || !timeSelect.value) {
      if (e) e.preventDefault();
      showPopup("Kindly fill the delivery date and time.", "Missing Information");
      return false;
    }
    return true;
  }

  // ===== CART DATE RESTRICTION =====
  // Checks if cart already contains items for a different delivery date.
  // Allows multiple cakes on the SAME date, blocks different dates.
  async function validateDeliveryDateBeforeCart(newDate) {
    try {
      const cart = await fetch("/cart.js").then(r => r.json());

      const existingDates = [];
      cart.items.forEach(item => {
        if (item.properties && item.properties["Delivery Date"]) {
          existingDates.push(item.properties["Delivery Date"]);
        }
      });

      const uniqueDates = [...new Set(existingDates)];

      if (uniqueDates.length > 0 && !uniqueDates.includes(newDate)) {
        showPopup(
          // `Your cart already has a cake scheduled for ${uniqueDates[0]}.\n\nPlease complete checkout for that order first before adding a cake for a different date.`,
          `Please generate a separate order for cakes required on different dates to ensure accurate scheduling and timely delivery.`,
          "A small request"
        );
        return false;
      }

      return true;

    } catch (error) {
      console.error("Cart validation error:", error);
      showPopup("Something went wrong while checking your cart. Please try again.", "Error");
      return false;
    }
  }

  // Initial run
  blockPastTimes();
  toggleButtons();

  // Date change handlers
  dateInput.addEventListener("change", function () {
    if (dateInput.value && dateInput.value < minDate) {
      dateInput.value = "";
      showPopup("You cannot select a past date.", "Invalid Date");
    }
    blockPastTimes();
    toggleButtons();
  });

  dateInput.addEventListener("input", function () {
    blockPastTimes();
    toggleButtons();
  });

  // Time change handler
  timeSelect.addEventListener("change", function () {
    if (!dateInput.value) {
      timeSelect.value = "";
      dateInput.focus();
      showPopup("Please select a delivery date first.", "Date Required");
      return;
    }
    const sel = timeSelect.selectedOptions?.[0];
    if (sel && sel.disabled) {
      timeSelect.value = "";
      showPopup("Selected time slot has already passed, please choose another slot.", "Time Unavailable");
    }
    toggleButtons();
  });

  // Re-check every minute to keep time slots up to date
  setInterval(function () {
    blockPastTimes();
    toggleButtons();
  }, 60 * 1000);

// ===== ADD TO CART BUTTON (FIXED) =====
if (addToCartBtn) {
  addToCartBtn.addEventListener("click", async function (e) {
    // Step 1: basic date + time check
    if (!validateInputs(e)) {
      e.stopImmediatePropagation();
      return;
    }

    // Step 2: check cart for a conflicting delivery date
    e.preventDefault();
    e.stopImmediatePropagation();

    const selectedDate = dateInput.value;
    const selectedTime = timeSelect.options[timeSelect.selectedIndex]?.text || timeSelect.value;
    const allowed = await validateDeliveryDateBeforeCart(selectedDate);

    if (allowed) {
      // Get the form and add delivery data as properties
      const form = addToCartBtn.closest("form") || document.querySelector('form[action^="/cart/add"]');
      
      if (form) {
        // Create or update hidden inputs for delivery date and time
        let dateInput_hidden = form.querySelector('input[name="properties[Delivery Date]"]');
        let timeInput_hidden = form.querySelector('input[name="properties[Delivery Time]"]');
        
        if (!dateInput_hidden) {
          dateInput_hidden = document.createElement('input');
          dateInput_hidden.type = 'hidden';
          dateInput_hidden.name = 'properties[Delivery Date]';
          form.appendChild(dateInput_hidden);
        }
        
        if (!timeInput_hidden) {
          timeInput_hidden = document.createElement('input');
          timeInput_hidden.type = 'hidden';
          timeInput_hidden.name = 'properties[Delivery Time]';
          form.appendChild(timeInput_hidden);
        }
        
        dateInput_hidden.value = selectedDate;
        timeInput_hidden.value = selectedTime;
        
        // Submit the form
        form.submit();
      }
    }
  }, true);
}

// ===== BUY NOW BUTTON (FIXED) =====
if (buyNowBtn) {
  buyNowBtn.addEventListener("click", async function (e) {
    // Step 1: basic date + time check
    if (!validateInputs(e)) {
      e.stopImmediatePropagation();
      return;
    }

    // Step 2: check cart for a conflicting delivery date
    e.preventDefault();
    e.stopImmediatePropagation();

    const selectedDate = dateInput.value;
    const selectedTime = timeSelect.options[timeSelect.selectedIndex]?.text || timeSelect.value;
    const allowed = await validateDeliveryDateBeforeCart(selectedDate);

    if (allowed) {
      // For buy now, we need to add to cart first then redirect to checkout
      const form = addToCartBtn.closest("form") || document.querySelector('form[action^="/cart/add"]');
      
      if (form) {
        // Add delivery properties
        let dateInput_hidden = form.querySelector('input[name="properties[Delivery Date]"]');
        let timeInput_hidden = form.querySelector('input[name="properties[Delivery Time]"]');
        
        if (!dateInput_hidden) {
          dateInput_hidden = document.createElement('input');
          dateInput_hidden.type = 'hidden';
          dateInput_hidden.name = 'properties[Delivery Date]';
          form.appendChild(dateInput_hidden);
        }
        
        if (!timeInput_hidden) {
          timeInput_hidden = document.createElement('input');
          timeInput_hidden.type = 'hidden';
          timeInput_hidden.name = 'properties[Delivery Time]';
          form.appendChild(timeInput_hidden);
        }
        
        dateInput_hidden.value = selectedDate;
        timeInput_hidden.value = selectedTime;
        
        // Add a parameter to redirect to checkout
        const formData = new FormData(form);
        formData.append('properties[Delivery Date]', selectedDate);
        formData.append('properties[Delivery Time]', selectedTime);
        
        // Submit to cart/add then redirect to checkout
        fetch('/cart/add', {
          method: 'POST',
          body: formData,
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          }
        }).then(response => {
          if (response.ok) {
            window.location.href = '/checkout';
          } else {
            showPopup('Error adding to cart. Please try again.', 'Error');
          }
        }).catch(error => {
          console.error('Error:', error);
          showPopup('Error adding to cart. Please try again.', 'Error');
        });
      }
    }
  }, true);
}

  // ===== FORM SUBMIT FALLBACK =====
  const form = document.querySelector('form[action^="/cart"]');
  if (form) {
    form.addEventListener("submit", function (e) {
      if (!validateInputs(e)) return;
    });
  }

  // Block /checkout links
  document.addEventListener("click", function (e) {
    const target = e.target.closest("a, button, input");
    if (target) {
      const href = target.getAttribute && target.getAttribute("href");
      if (href && href.includes("/checkout")) {
        if (!validateInputs(e)) {
          e.stopImmediatePropagation();
          e.preventDefault();
        }
      }
    }
  }, true);

  const checkoutForms = document.querySelectorAll('form[action^="/checkout"]');
  checkoutForms.forEach(f => f.addEventListener("submit", validateInputs));
});


// ===== FLAVOUR SELECTS: duplicate prevention + strict validation =====
(function () {
  "use strict";

  const FORM_SELECTOR = ".product__form";
  const SELECTOR_CLASS = ".piece-select";
  const SUBMIT_BUTTON_SELECTOR = ".product__form-submit";
  const PAYMENT_BUTTON_SELECTORS = [
    "[data-payment-button]",
    "[data-payment-button-quickview]",
    ".shopify-payment-button",
    ".product__form-buttons button[type='button'][data-shopify-payments]",
  ];

  function log(...args) { if (window.console) console.log("[Flavours]", ...args); }

  // Custom popup for flavours
  function showFlavourPopup(message) {
    const existingPopup = document.querySelector('.custom-popup-overlay');
    if (existingPopup) existingPopup.remove();

    const overlay = document.createElement('div');
    overlay.className = 'custom-popup-overlay';
    overlay.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.5);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 99999;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
    `;

    const popup = document.createElement('div');
    popup.className = 'custom-popup';
    popup.style.cssText = `
      background: white;
      border-radius: 12px;
      padding: 24px;
      max-width: 400px;
      width: 90%;
      box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
      animation: slideIn 0.3s ease-out;
    `;

    const titleEl = document.createElement('h3');
    titleEl.textContent = 'Flavours Required';
    titleEl.style.cssText = `
      margin: 0 0 12px 0;
      font-size: 20px;
      font-weight: 600;
      color: #333;
    `;

    const messageEl = document.createElement('p');
    messageEl.textContent = message;
    messageEl.style.cssText = `
      margin: 0 0 20px 0;
      font-size: 16px;
      line-height: 1.5;
      color: #666;
    `;

    const buttonContainer = document.createElement('div');
    buttonContainer.style.cssText = `
      display: flex;
      justify-content: flex-end;
      gap: 12px;
    `;

    const okButton = document.createElement('button');
    okButton.textContent = 'OK';
    okButton.style.cssText = `
      padding: 10px 24px;
      background: #000;
      color: white;
      border: none;
      border-radius: 6px;
      font-size: 14px;
      font-weight: 500;
      cursor: pointer;
      transition: background 0.2s;
    `;
    okButton.onmouseover = () => okButton.style.background = '#ccc';
    okButton.onmouseout = () => okButton.style.background = '#00000085';
    okButton.onclick = () => overlay.remove();

    buttonContainer.appendChild(okButton);
    popup.appendChild(titleEl);
    popup.appendChild(messageEl);
    popup.appendChild(buttonContainer);
    overlay.appendChild(popup);
    document.body.appendChild(overlay);

    overlay.onclick = (e) => {
      if (e.target === overlay) overlay.remove();
    };
  }

  function updateOptionsWithin(form) {
    const selects = Array.from(form.querySelectorAll(SELECTOR_CLASS));
    const selectedValues = selects.map(s => s.value).filter(v => v !== "");

    selects.forEach(select => {
      const current = select.value;
      Array.from(select.options).forEach(option => {
        if (option.value !== "" && option.value !== current && selectedValues.includes(option.value)) {
          option.disabled = true;
        } else {
          option.disabled = false;
        }
      });
    });
  }

  function validateSelects(form) {
    const selects = Array.from(form.querySelectorAll(SELECTOR_CLASS));
    let valid = true;
    let firstInvalid = null;

    selects.forEach(select => {
      if (!select) return;
      if (select.value === "" || select.value == null) {
        valid = false;
        select.classList.add("piece-select--invalid");
        select.style.outline = "2px solid #d9534f";
        if (!firstInvalid) firstInvalid = select;
      } else {
        select.classList.remove("piece-select--invalid");
        select.style.outline = "";
      }
    });

    return { valid, firstInvalid };
  }

  function attachHandlersToForm(form) {
    if (!form || form.dataset.flavoursInit === "true") return;
    form.dataset.flavoursInit = "true";
    log("Initializing on form", form);

    updateOptionsWithin(form);

    form.addEventListener("change", function (e) {
      if (e.target.matches(SELECTOR_CLASS) || e.target.closest(SELECTOR_CLASS)) {
        updateOptionsWithin(form);
        e.target.style.outline = "";
      }
    });

    form.addEventListener("submit", function (e) {
      const { valid, firstInvalid } = validateSelects(form);
      if (!valid) {
        e.preventDefault();
        e.stopImmediatePropagation();
        log("Form submit blocked — missing flavours");
        if (firstInvalid) firstInvalid.focus({ preventScroll: false });
        showFlavourPopup("Please select all flavours before adding to cart / buying.");
      }
    }, true);

    const submitButtons = Array.from(form.querySelectorAll(SUBMIT_BUTTON_SELECTOR));
    submitButtons.forEach(btn => {
      btn.addEventListener("click", function (e) {
        const { valid, firstInvalid } = validateSelects(form);
        if (!valid) {
          e.preventDefault();
          e.stopImmediatePropagation();
          log("Add to cart click blocked — missing flavours (button)");
          if (firstInvalid) firstInvalid.focus({ preventScroll: false });
          showFlavourPopup("Please select all flavours before adding to cart.");
          return false;
        }
        return true;
      }, true);
    });

    PAYMENT_BUTTON_SELECTORS.forEach(sel => {
      Array.from(form.querySelectorAll(sel)).forEach(btn => {
        btn.addEventListener("click", function (e) {
          const { valid, firstInvalid } = validateSelects(form);
          if (!valid) {
            e.preventDefault();
            e.stopImmediatePropagation();
            log("Payment button click blocked — missing flavours", btn);
            if (firstInvalid) firstInvalid.focus({ preventScroll: false });
            showFlavourPopup("Please select all flavours before proceeding to payment.");
            return false;
          }
          return true;
        }, true);
      });
    });

    const observer = new MutationObserver(function (mutations) {
      let reinit = false;
      for (const m of mutations) {
        if (m.addedNodes && m.addedNodes.length) { reinit = true; break; }
      }
      if (reinit) {
        log("Mutation detected — re-applying handlers");

        Array.from(form.querySelectorAll(SUBMIT_BUTTON_SELECTOR)).forEach(btn => {
          if (!btn.dataset.flavoursBtnInit) {
            btn.dataset.flavoursBtnInit = "true";
            btn.addEventListener("click", function (e) {
              const { valid, firstInvalid } = validateSelects(form);
              if (!valid) {
                e.preventDefault();
                e.stopImmediatePropagation();
                log("Add to cart click blocked (mutation) — missing flavours");
                if (firstInvalid) firstInvalid.focus({ preventScroll: false });
                showFlavourPopup("Please select all flavours before adding to cart.");
                return false;
              }
              return true;
            }, true);
          }
        });

        PAYMENT_BUTTON_SELECTORS.forEach(sel => {
          Array.from(form.querySelectorAll(sel)).forEach(btn => {
            if (!btn.dataset.flavoursBtnInit) {
              btn.dataset.flavoursBtnInit = "true";
              btn.addEventListener("click", function (e) {
                const { valid, firstInvalid } = validateSelects(form);
                if (!valid) {
                  e.preventDefault();
                  e.stopImmediatePropagation();
                  log("Payment click blocked (mutation) — missing flavours");
                  if (firstInvalid) firstInvalid.focus({ preventScroll: false });
                  showFlavourPopup("Please select all flavours before proceeding to payment.");
                  return false;
                }
                return true;
              }, true);
            }
          });
        });

        updateOptionsWithin(form);
      }
    });

    observer.observe(form, { childList: true, subtree: true });
    form._flavoursObserver = observer;
  }

  function waitForFormsAndInit() {
    const existingForms = document.querySelectorAll(FORM_SELECTOR);
    if (existingForms.length) {
      existingForms.forEach(f => attachHandlersToForm(f));
    }

    const docObserver = new MutationObserver(function (mutations) {
      for (const m of mutations) {
        if (!m.addedNodes) continue;
        m.addedNodes.forEach(node => {
          if (!(node instanceof HTMLElement)) return;
          if (node.matches && node.matches(FORM_SELECTOR)) {
            attachHandlersToForm(node);
          } else {
            const nested = node.querySelector && node.querySelector(FORM_SELECTOR);
            if (nested) attachHandlersToForm(nested);
          }
        });
      }
    });

    docObserver.observe(document.documentElement || document.body, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", waitForFormsAndInit);
  } else {
    waitForFormsAndInit();
  }

  window._flavours_debug = {
    validateAll: function () {
      const f = document.querySelector(FORM_SELECTOR);
      if (!f) { log("No form found"); return; }
      log(validateSelects(f));
      return validateSelects(f);
    },
    updateOptions: function () {
      const f = document.querySelector(FORM_SELECTOR);
      if (!f) { log("No form found"); return; }
      updateOptionsWithin(f);
      log("updateOptions applied");
    }
  };

})();